import SeminarCard, { SeminarCardProps } from './SeminarCard.component';

export type SeminarCardType = SeminarCardProps;

export default SeminarCard;
